import { useMemo } from 'react';
import { useAuthState } from 'state';
import { AccountInfo } from 'types';
import ApiService from './ApiService';

export class AccountService extends ApiService {
    async getAccountList() : Promise<AccountInfo[]>{
        const { data, status } = await this.get(`/api/accounts/current`);
        return this.IsSuccessStatusCode(status) ? data : [];
    }
}

export const useAccountService = () => {
    const auth = useAuthState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo(() => new AccountService(), [auth]);
};